import React from 'react'
import { useNavigate } from 'react-router'

interface ClickableItemCard {
    path?: string
    children: React.ReactNode[] | React.ReactNode
    className?: string
    handleOnClick?: (event: React.MouseEvent) => void
    id?: string
}

const ClickableItemCard = (props: ClickableItemCard) => {
    const navigate = useNavigate()
    const handleOnClick = (event: React.MouseEvent) => {
        if (props.handleOnClick) {
            props.handleOnClick(event)
        }
        if (props.path) {
            navigate(props.path)
        }
    }
    return (
        <div className={props.className} onClick={handleOnClick} id={props.id}>
            {props.children}
        </div>
    )
}

export { ClickableItemCard }
